var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSparks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 188,
    viewBox: "0 0 175 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1638 186.317C126.408 186.317 161.466 151.258 161.466 107.86C161.466 64.4614 126.408 29.4028 83.1638 29.4028C39.9197 29.4028 4.86108 64.4614 4.86108 107.86C4.86108 151.258 39.9197 186.317 83.1638 186.317Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5564 57.0481H136.91C141.389 57.0481 144.787 60.4458 144.787 64.9247V135.505C144.787 139.984 141.389 143.382 136.91 143.382H25.5564C21.0776 143.382 17.6798 139.984 17.6798 135.505V64.9247C17.6798 60.4458 21.3865 57.0481 25.5564 57.0481Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.949 102.3V137.05C146.949 141.529 143.397 145.235 138.763 145.235H24.3209C19.842 145.235 16.1354 141.529 16.1354 137.05V99.3656",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.219 82.8402H101.079C97.527 82.8402 94.1292 84.0758 91.5037 86.238L82.0827 93.9601C79.4571 96.1223 76.0594 97.3579 72.5072 97.3579H31.7342C27.5642 97.3579 24.1665 100.756 24.1665 104.926C24.1665 105.234 24.1665 105.698 24.3209 106.007L31.8886 145.853C32.5064 149.56 35.5953 152.34 39.4563 152.34H126.717C130.423 152.34 133.667 149.714 134.284 146.007L144.787 91.489C145.559 87.3191 142.779 83.6124 138.609 82.8402C137.991 82.8402 137.528 82.8402 137.219 82.8402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.435 72.1836H106.485C101.851 72.1836 97.527 73.728 93.9748 76.6625L81.6194 86.7013C78.2216 89.4813 73.7428 91.1801 69.1095 91.1801H15.981C10.5755 91.1801 6.2511 95.659 6.2511 100.91C6.2511 101.373 6.2511 101.837 6.40555 102.3L16.1355 154.347C16.9077 159.29 21.0776 162.842 25.8654 162.842H139.536C144.478 162.842 148.493 159.444 149.265 154.502L163.011 83.3035C163.938 77.898 160.385 73.1103 154.98 72.0292C154.517 72.1836 153.899 72.1836 153.435 72.1836Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6228 126.084C65.4028 126.084 67.7194 123.768 67.7194 120.988C67.7194 118.208 65.4028 115.891 62.6228 115.891C59.8428 115.891 57.5262 118.208 57.5262 120.988C57.5262 123.768 59.8428 126.084 62.6228 126.084Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.315 125.93C105.095 125.93 107.411 123.613 107.411 120.833C107.411 118.053 105.095 115.737 102.315 115.737C99.5347 115.737 97.2181 118.053 97.2181 120.833C97.2181 123.768 99.5347 125.93 102.315 125.93Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.44 157.193C164.929 159.364 164.163 161.663 163.269 163.579C160.842 168.304 157.011 172.007 152.286 174.434C147.433 176.86 141.686 177.882 135.939 176.605C122.402 173.795 113.718 160.514 116.528 146.977C119.337 133.44 132.491 124.628 146.028 127.565C150.881 128.587 155.096 131.013 158.671 134.334C164.674 140.336 167.228 149.02 165.44 157.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141 127C127.2 127 116 138.2 116 152C116 165.8 127.2 177 141 177C154.8 177 166 165.8 166 152C166 138.2 154.8 127 141 127ZM133.5 172L138.5 154.5H128.5L148.5 132L143.5 149.5H153.5L133.5 172Z",
    fill: "#A7B3C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2138 89.4813C70.6539 78.6703 69.4183 65.6971 73.125 53.9594C76.6771 42.2217 85.1715 32.1829 95.6736 26.4685C98.917 24.7696 102.624 23.3796 106.33 23.2252C110.037 23.0708 114.052 24.3063 116.523 27.3952C118.995 30.1751 119.458 34.8084 117.45 37.8973C115.288 40.8317 110.964 42.0673 107.411 41.1406C101.697 40.0595 97.0636 35.5807 95.6736 30.1751C94.2837 24.7696 96.137 18.4375 100.461 14.8853C103.241 12.4142 107.102 11.0242 110.655 9.94309C127.952 4.84647 146.794 4.22869 164.401 8.08977",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3337 131.49H77.7583V133.806H87.3337V131.49Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.667 4.07412C173.513 6.39077 173.359 8.55298 171.66 9.0163C169.961 9.47963 169.189 7.9352 168.107 5.773C167.026 3.76524 167.644 1.60303 169.497 1.1397C171.196 0.676376 173.976 1.29415 173.667 4.07412Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.814 15.1941C172.277 12.4141 172.741 10.8697 171.196 10.0975C169.497 9.32525 168.416 10.7152 166.563 12.5686C165.019 14.2674 165.945 16.7385 167.49 17.5107C169.343 18.4374 171.351 17.5107 171.814 15.1941Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.976 10.0976C173.822 11.1787 173.05 11.9509 171.969 12.1054C171.505 12.1054 171.042 12.1054 170.424 12.1054C168.262 11.7965 166.563 10.4065 166.718 9.01651C166.872 7.62652 168.88 6.8543 171.351 7.16319C171.814 7.16319 172.277 7.31763 172.586 7.47207C173.513 7.78096 174.131 8.86206 173.976 10.0976C173.976 9.94316 173.976 10.0976 173.976 10.0976Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.976 10.0976C173.822 11.1787 173.05 11.9509 171.969 12.1054C171.505 12.1054 171.042 12.1054 170.424 12.1054C168.262 11.7965 166.563 10.4065 166.718 9.01651C166.872 7.62652 168.88 6.8543 171.351 7.16319C171.814 7.16319 172.277 7.31763 172.586 7.47207C173.513 7.78096 174.131 8.86206 173.976 10.0976ZM173.976 10.0976C173.976 9.94316 173.976 10.0976 173.976 10.0976Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.61781 53.4961C1.61781 50.8705 1.61781 48.245 3.47113 47.4728C5.47889 46.7006 6.55999 48.5539 8.10442 51.1794C9.49441 53.4961 8.87664 55.9671 6.86888 56.7394C5.17 57.5116 1.61781 57.0482 1.61781 53.4961Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69887 40.5228C2.38998 43.7661 1.92666 45.6194 3.93442 46.3916C5.94218 47.1638 7.02328 45.465 9.03104 42.9939C10.5755 40.8317 9.49437 38.0517 7.48661 37.2795C5.47885 36.5072 3.00776 37.8972 2.69887 40.5228Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 46.7005C1 45.465 1.92666 44.5383 3.00776 44.3839C3.47109 44.2295 4.08886 44.2295 4.70664 44.3839C7.17773 44.5383 9.33993 45.9283 9.18549 47.4728C9.03104 49.0172 7.02328 50.0983 4.39775 49.7894C3.93442 49.7894 3.47109 49.635 3.00776 49.4805C1.77222 49.3261 1 48.0905 1 46.7005Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5021 47.1638C27.7186 47.1638 57.6806 56.5849 58.1439 91.1801",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSparks);
export default __webpack_public_path__ + "static/media/NoSparks.bcb090eb87f84baf6e462ed9646774ce.svg";
export { ForwardRef as ReactComponent };